import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import Dashboard from "@/pages/Dashboard";
import NewEstimation from "@/pages/NewEstimation";
import EstimationResult from "@/pages/EstimationResult";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";

function AppRouter() {
  const location = useLocation();

  // CRITICAL: Check URL fragment for session_id synchronously before rendering routes
  // This prevents race conditions with ProtectedRoute
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            {({ user }) => <Dashboard user={user} />}
          </ProtectedRoute>
        }
      />
      <Route
        path="/new-estimation"
        element={
          <ProtectedRoute>
            {({ user }) => <NewEstimation user={user} />}
          </ProtectedRoute>
        }
      />
      <Route
        path="/estimation/:id"
        element={
          <ProtectedRoute>
            {({ user }) => <EstimationResult user={user} />}
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
